<ng-container *ngIf="shoppingCart$ | async as shoppingCart">
  <vnm-sidebar-toggle
    #cartToggle
    [label]="buttonLabel | translate"
    [icon]="faIcon"
    [buttonClass]="buttonClass"
    (dismiss)="onDismiss()"
  >
    <ng-template #toggle>
      <vnm-checkout-wizard [currentUser]="currentUser" [shoppingCart]="shoppingCart"></vnm-checkout-wizard>
    </ng-template>
  </vnm-sidebar-toggle>

  <vnm-badge *ngIf="shoppingCart.cartItems.length" class="cart-badge" @fade>
    {{ shoppingCart.cartItems | totalQuantity }}
  </vnm-badge>
</ng-container>
